// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FQ5y5"};